import { values } from 'lodash';
import { StepType } from '@doltech/ui/lib/figma/Steps/StepsV2';

export const NamedStepEnum = {
  BASIC_INFO: 0,
  INPUT_DATA: 1,
  QUESTION_GROUP: 2,
  LIST_VOCAB: 3,
  ASSIGN_TO: 4,
} as const;

export type NamedStepEnum = (typeof NamedStepEnum)[keyof typeof NamedStepEnum];

export const createBookStepLabels: StepType[] = [
  {
    name: 'Basic info',
    status: 'wait',
  },
  { name: 'Chọn Test', status: 'wait' },
  { name: 'Review & Update', status: 'wait' },
];

export const TOTAL_STEP = values(NamedStepEnum).length;

export const defaultSingleOptions: any = [
  { key: 0, value: '' },
  { key: 1, value: '' },
  { key: 2, value: '' },
];

export const defaultCorrectAnswer = {
  value: '',
  blankId: '',
};

export const generateCorrectAnswer = (options: any) => ({
  ...defaultCorrectAnswer,
  ...options,
});

export const defaultCorrectAnswers = [
  generateCorrectAnswer({ key: 0 }),
  generateCorrectAnswer({ key: 1 }),
  generateCorrectAnswer({ key: 2 }),
];

export const PASSAGE_TYPE_OPTION = [
  { key: 'PASSAGE1', value: 'Passage 1' },
  { key: 'PASSAGE2', value: 'Passage 2' },
  { key: 'PASSAGE3', value: 'Passage 3' },
];
export const SECTION_TYPE_OPTION = [
  { key: 'SECTION1', value: 'Section 1' },
  { key: 'SECTION2', value: 'Section 2' },
  { key: 'SECTION3', value: 'Section 3' },
  { key: 'SECTION4', value: 'Section 4' },
];
